import homeFallbackContent from "../lib/fallbackContent/home";
import { mergeCmsSection } from "../lib/mergeCmsSection";
import { apiBaseUrl } from "../lib/cmsApi";
import { resolveCmsImage } from "../lib/cmsAssets";

/**
 * Our Impact Areas — design: yellow arc, navy titles, white icon badge,
 * rounded card with ONLY bottom-right diagonal cut.
 */
export default function ImpactAreas({ data }) {
  const section = mergeCmsSection(data, homeFallbackContent.impact_areas);
  const items = Array.isArray(section.items) ? section.items : [];

  return (
    <div className="relative z-10 mx-auto max-w-7xl px-4 pt-4 pb-6 sm:px-8 sm:pt-6 lg:px-10">
      <div className="relative mx-auto flex w-full flex-col items-center">
        <h2 className="text-center text-[24px] font-bold leading-tight text-[#183B56] sm:text-[32px] lg:text-[42px]">
          {section.title || "Our Impact Areas"}
        </h2>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-7 sm:mt-12 sm:gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 lg:px-2">
        {items.map((area, index) => {
          const imageSrc =
            resolveCmsImage(area.image, apiBaseUrl) || resolveCmsImage(area.imageKey, apiBaseUrl);
          const iconSrc =
            resolveCmsImage(area.icon, apiBaseUrl) || resolveCmsImage(area.iconKey, apiBaseUrl);

          return (
            <article
              key={area.title || index}
              className="group relative flex w-full flex-col bg-white shadow-[0_10px_28px_rgba(24,59,86,0.12)] transition hover:shadow-[0_14px_34px_rgba(24,59,86,0.16)]"
              style={{
                borderRadius: "18px 18px 0 18px",
                clipPath:
                  "polygon(0 0, 100% 0, 100% calc(100% - 48px), calc(100% - 48px) 100%, 0 100%)",
              }}
            >
              <div className="relative z-10 shrink-0">
                <div className="aspect-[4/3] overflow-hidden rounded-t-[18px]">
                  <img
                    src={imageSrc}
                    alt={area.alt || area.title || ""}
                    loading="lazy"
                    className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]"
                  />
                </div>

                {iconSrc ? (
                  <div
                    className="absolute bottom-0 right-4 z-20 flex h-12 w-12 translate-y-1/2 items-center justify-center rounded-full bg-white shadow-[0_4px_14px_rgba(24,59,86,0.18)] sm:right-5 sm:h-[52px] sm:w-[52px]"
                    aria-hidden
                  >
                    <img
                      src={iconSrc}
                      alt=""
                      className="h-6 w-6 object-contain sm:h-7 sm:w-7"
                    />
                  </div>
                ) : null}
              </div>

              <div className="relative z-0 flex flex-1 flex-col px-5 pb-8 pt-9 sm:px-6 sm:pb-9 sm:pt-10">
                <h3 className="text-[17px] font-bold leading-snug text-[#183B56] sm:text-[18px]">
                  {area.title}
                </h3>
                <p className="mt-2.5 text-[14px] leading-relaxed text-slate-600 sm:text-[15px]">
                  {area.description}
                </p>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
